import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { HsButtonModule, HsDividerModule } from '@hsetu/ngui-components';
import { HsLayerDirective } from '@hsetu/ngui-resources';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'kfm-info-dialog',
  standalone: true,
  imports: [CommonModule, HsLayerDirective, HsDividerModule, HsButtonModule],
  templateUrl: './kfm-info-dialog.component.html',
})
export class KfmInfoDialogComponent {
  private readonly _data = inject<{ title: string; text: string }>(DIALOG_DATA);

  protected readonly dialogRef = inject<DialogRef<void>>(DialogRef);

  protected get title() {
    return this._data.title;
  }

  protected get text() {
    return this._data.text;
  }
}
